// extracted by mini-css-extract-plugin
module.exports = {"bkg":"Error_bkg__3Uz_K","titleError":"Error_titleError__cxwZ7","iconContainer":"Error_iconContainer__2XKjj","text":"Error_text__1KKOg"};